import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { IDI_CUSTOMER_SEARCH_START_LOADING, IDI_CUSTOMER_SEARCH_END_LOADING, IDI_CUSTOMER_SEARCH_LOADED, SET_IDI_CUSTOMER_FILTER } from "../constants/IdiCustomerConstants";
import { IDI_CUSTOMER_START_LOADING, IDI_CUSTOMER_END_LOADING, IDI_CUSTOMER_LOADED } from "../constants/IdiCustomerConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        customer: {
            type: "customer",
            pageIndex: 1,
            pageSize: SEARCH_PAGE_SIZE,
            search: "",
            active: ""
        },
        owner: {
            type: "owner",
            pageIndex: 1,
            pageSize: SEARCH_PAGE_SIZE,
            search: "",
            active: ""
        },
    },    
    loadingFBO: false,
    fbo: null,
};

const IdiCustomerReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_CUSTOMER_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_CUSTOMER_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case IDI_CUSTOMER_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_IDI_CUSTOMER_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case IDI_CUSTOMER_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case IDI_CUSTOMER_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case IDI_CUSTOMER_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IdiCustomerReducer;